export default __webpack_public_path__ + "static/media/close-icon-white.bb8d96b1.svg";